import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { actions as shareToEmailActions } from '../../../../../redux/healthboard/patientPortal/share-to-email-req';
import { shareToEmailModalActions } from '../../../../../redux/healthboard/patientPortal/share-to-email-modal';
import {
  shareToEmailModalDocumentUid,
  shareToEmailModal,
} from '../../../../../redux/healthboard/patientPortal/selectors';
import {
  loggedUserIdSelector,
  targetUserIdSelector,
} from '../../../../../redux/context/selectors';

const mapStateToProps = state => ({
  openedShareToEmailModal: shareToEmailModal(state),
  mainUserId: loggedUserIdSelector(state),
  targetUserId: targetUserIdSelector(state),
  documentUid: shareToEmailModalDocumentUid(state),
});

const mapDispatchToProps = {
  close: shareToEmailModalActions.close,
  shareToEmail: shareToEmailActions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/ShareToEmailModal/enhance.js